import * as Yup from "yup";

export const DeliveryTypeValidation = Yup.object().shape({
  name: Yup.string().required("Delivery type is required"),
  factor: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required("Factor name is required"),
        value: Yup.number().required("Factor value is required").positive("Value must be a positive number"),
      })
    )
    .min(1, "At least one factor is required"), // Ensures at least one factor
});
